export interface NotificationMessage {
  key: string;
  params?: Record<string, any>;
}

export const getNotificationMessage = (
  notification: string | NotificationMessage | undefined,
  translate: (key: string, params?: any) => string
): string => {
  if (!notification) return "";

  if (typeof notification === 'string') {
    return String(translate(notification, {}));
  }

  return String(translate(notification.key, notification.params || {}));
};
